export { default } from './makeStyles';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/styles/esm/makeStyles/index.js
// module id = 237
// module chunks = 0